import React from 'react'
import Modal from "react-bootstrap/Modal"

export default function ProjectLimitExceedModal(props) {
        const [showModal, setShowModal] = React.useState(false)

        React.useEffect(() => {
                setShowModal(props.showCondition)
        }, [setShowModal, props])
        return (
                <React.Fragment>
                        <Modal show={showModal}>
                                <Modal.Header>
                                        <h3>Limit Exceed</h3>
                                </Modal.Header>
                                <Modal.Body>
                                        Your project creation limit exceeded
                                </Modal.Body>
                                <Modal.Footer>
                                        <button onClick={() => {setShowModal(false)}} className="btn btn-danger" >Cancel</button>
                                </Modal.Footer>
                        </Modal>
                </React.Fragment>
        )
}
